import axios from 'axios';
import http from './config'

let base = http.base_url;//正式环境https://api.rls.danjiguanjia.com 测试环境 https://api.dev.danjiguanjia.com"
let base2 = http.base2_url;//https://api.danjiguanjia.com
let base3 = http.base3_url; // http://breed.danjiguanjia.com

let config = {
    headers: {
        'Content-Type':'multipart/form-data',
        'Content-Type':'Access-Contol-Allow-Origin'
    }
}

//登录
export const userLogin = params =>{
    let param = new FormData();
    param.append('user_name',params.user_name);
    param.append('user_pwd',params.user_pwd);
    param.append('decive',params.decive);
    return axios.post(`${base}/api/v1/User/pclogin`,param, config).then(res => res.data);
}

//验证码登录
export const pc_mobile_login = params =>{
    let param = new FormData();
    param.append('user_name',params.user_name);
    param.append('code',params.code);
    param.append('decive',params.decive);
    return axios.post(`${base}/api/v1/User/pc_mobile_login`,param, config).then(res => res.data);
}

//首页banner
export const indexBanner = params => {
    return axios.get(`${base}/api/v1/news/getbanner`, params).then(res => res.data)
}
export const getBanner_pc = params => {
    return axios.get(`${base}/api/v1/news/getBanner_pc`, params).then(res => res.data)
}

//首页下获取公司信息
export const getContact = params => {
    return axios.get(`${base}/api/v1/news/getContact`, params).then(res => res.data)
}

//价格行情
export const quotationLists = params =>{
    let param = new FormData();
    param.append('page',params.page);
    return axios.post(`${base}/api/v4/Quotation/quotation`,param, config).then(res => res.data);
}

//淘汰鸡
export const outQuotationLists = params =>{
    let param = new FormData();
    param.append('page',params.page);
    return axios.post(`${base}/api/v4/OutChicken/outQuotation`,param, config).then(res => res.data);
}

//金鸡讲堂
export const videoHot = params => {
    return axios.get(`${base}/api/v1/video/getHot_new`,{
     params: params
    }).then(res => res.data)
}

//新闻
export const newsData = params => {
    return axios.get(`${base}/api/v1/news/getNews`,{
     params: params
    }).then(res => res.data)
}

//管家视界的首页banner
export const videoBanner = params => {
	return axios.get(`${base}/api/v1/video/getBanner`, params).then(res => res.data);
};

//金牌讲师列表
export const videoTeacherList = params => {
	return axios.get(`${base}/api/v1/video/teacher_new`, params).then(res => res.data);
};

//养殖课堂列表
export const videoBreedList = params => {
	return axios.get(`${base}/api/v1/video/breed_video_new`, {
		params: params
	}).then(res => res.data);
};

//文章收藏列表
export const newsCollect = params => {
	return axios.get(`${base}/api/v1/search/newsCollect`, {
		params: params
	}).then(res => res.data);
};

//视频收藏列表
export const videoCollect = params => {
	return axios.get(`${base}/api/v1/search/videoCollect`, {
		params: params
	}).then(res => res.data);
};

//视频详情页
export const videoDetail = params => {
	return axios.get(`${base}/api/v1/video/getVideo_new`, {
		params: params
	}).then(res => res.data);
};

//新闻详情页面
export const getNewsDetail = params => {
	return axios.get(`${base}/api/v1/News/getNewsDetail`, {
		params: params
	}).then(res => res.data);
};

//新闻热门推荐
export const getRedRecommendNew = params => {
	return axios.get(`${base}/api/v1/news/getRedRecommendNew`, {
		params: params
	}).then(res => res.data);
};

//视频添加收藏
export const addVideoCollect = params => {
	return axios.get(`${base}/api/v1/search/addVideoCollect`, {
		params: params
	}).then(res => res.data);
};

//视频取消收藏
export const delVideoCollect = params => {
	return axios.get(`${base}/api/v1/search/delVideoCollect`, {
		params: params
	}).then(res => res.data);
};


//购买
export const placeOrder = params =>{
    let param = new FormData();
	param.append('group_name',params.group_name);
	param.append('payment_amount',params.payment_amount);
	param.append('user_name',params.user_name);
	param.append('phone',params.phone);
	param.append('address',params.address);
	param.append('years_purchase',params.years_purchase);
	param.append('order_type',params.order_type);
	param.append('package_type',params.package_type);
	param.append('ticket',params.ticket);
    return axios.post(`${base3}/api/order/placeOrder`,param, config).then(res => res.data);
};

//获取购买信息
export const getDetailById = params => {
	return axios.get(`${base3}/api/order/getDetailById`, {
		params: params
	}).then(res => res.data);
};

//年限信息
export const getPriceByType = params => {
	return axios.get(`${base3}/api/order/getPriceByType`, {
		params: params
	}).then(res => res.data);
};

//更改订单状态
export const updateOrderStatus = params =>{
    let param = new FormData();
	param.append('id',params.id);
	param.append('pay_type',params.pay_type);
	param.append('ticket',params.ticket);
    return axios.post(`${base3}/api/Order/updateOrderStatus`,param, config).then(res => res.data);
};

//验证码
export const identifyingCodes = params => {
	let param = new FormData(); //创建form对象
	param.append('phone', params.phone);
	return axios.post(`${base}/api/v1/user/sendVerCodes_h5`, param, config).then(res => res.data);
};

//用户找回密码
export const forgetPassword = params => {
	return axios.get(`${base2}/v4/user/forgetPassword`, {
		params: params
	}).then(res => res.data);
};


//用户修改密码
export const pcforgetPassword = params => {
	let param = new FormData(); //创建form对象
	param.append('mobile_phone', params.mobile_phone);
	param.append('password', params.password);
	param.append('opassword',params.opassword);
	return axios.post(`${base}/api/v1/User/pcforgetPassword`, param, config).then(res => res.data);
};



//注册
export const registerpc = params => {
	let param = new FormData(); //创建form对象
	param.append('user_name', params.user_name);
	param.append('user_pwd', params.user_pwd);
	param.append('re_pwd', params.re_pwd);
	param.append('code', params.code);
	param.append('phone', params.phone);
	return axios.post(`${base}/api/v1/User/registerpc`, param, config).then(res => res.data);
};

//长连接消息
export const webSocketCallBack = params =>{
    let param = new FormData();
	param.append('client_id',params.client_id);
	param.append('ticket',params.ticket);
    return axios.post(`${base3}/api/index/bind_pc`,param, config).then(res => res.data);
};

//消息列表
export const getmessagelist = params => {
	return axios.get(`${base3}/api/menu/getmessagelist_pc`, {
		params: params
	}).then(res => res.data);
};

//消息已读
export const readMessage = params => {
	return axios.get(`${base3}/api/menu/readMessage`, {
		params: params
	}).then(res => res.data);
};


//oauth 请求
export const getOauthUser = params =>{
    let param = new FormData();
	param.append('code',params.code);
	param.append('start_time',params.start_time);
	param.append('end_time',params.end_time);
    return axios.post(`http://192.168.3.42/api/v4/Oauth/getOauthUser`,param, config).then(res => res.data);
};


//长连接消息
export const webSocketCallBackOauth = params =>{
    let param = new FormData();
	param.append('client_id',params.client_id);
	param.append('oauth_id',params.oauth_id);
    return axios.post(`http://192.168.3.42/api/index/bind_oauth`,param, config).then(res => res.data);
};


// WEBPACK FOOTER //
// ./src/api/api.js